<template>
    <el-select
            v-model="currentValue"
            :size="size"
            :multiple="multiple"
            :collapse-tags="collapseTags"
            :filterable="filterable"
            :disabled="disabled"
            :clearable="clearable"
            @change="change($event)" :class="{'width100': width100}">
        <el-option v-for="customer in customers" :key="customer.id"
                :value="customer.id" :label="customer.name">

        </el-option>
    </el-select>
</template>

<script>
    import BillingServer from "@/api/billing";
    export default {
        name: "CustomerSelect",
        props: {
            value: {},
            size: {},
            multiple: {},
            collapseTags: {},
            filterable: {},
            disabled: {},
            clearable: {},
            width100: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                currentValue: null,
                customers: []
            };
        },
        watch: {
            value: {
                deep: true,
                immediate: true,
                handler(value) {
                    this.currentValue = value;
                }
            }
        },
        methods: {
            async load(search) {
                search = search == null ? {} : search;
                let res = await BillingServer.customer.list(search);
                let customers;
                if (res.data.success) {
                    customers = res.data.data;
                }
                customers = customers == null ? [] : customers;
                customers.forEach(e => {
                    e.id = parseInt(e.id);
                });
                this.customers = customers;
                return Promise.resolve(customers);
            },
            change(event) {
                let customers = event != null && event !== '' ? this.customers.filter(e => String(e.id) === String(event)) : null;
                let customer = customers != null && customers.length > 0 ? customers[0] : null;
                this.$emit('input', event);
                this.$emit('change', event, customer);
            },
        },
        mounted() {
            this.load();
        },
    }
</script>

<style scoped>

</style>